module.exports = __webpack_public_path__ + "img/vsHandCream6.c2558bf2.jpg";